import Dashboard from './Dashboard';

export default function HomePage() {
  return <Dashboard />
}
